import { FC, Fragment } from "react";
import { Theme } from "@mui/material/styles";
import withStyles from '@mui/styles/withStyles';
import {
    List,
    ListItem,
    ListItemText,
    Divider,
    Drawer
} from "@mui/material";
import { Box } from '@mui/material';
import { withAuthProvider } from '../../hoc/auth';
import { AuthComponentProps } from '../../hoc/auth/AuthProvider';
import { useHistory } from 'react-router-dom';

const styles = (theme: Theme) => ({
    list: {
        paddingTop: theme.deloitte.menuSize,
        width: 250
    },
    fullList: {
        width: "auto"
    }
});

export interface IDrawerMenuProps extends AuthComponentProps {
    classes: any;
    toggleDrawerHandler: () => void;
    updateTab: (event: any, index: number) => void;
    opened: boolean;
}

const DrawerMenu: FC<IDrawerMenuProps> = (props) => {
    const { classes, opened, updateTab, user, logout, login } = props;
    const history = useHistory();
    const sideList = () => (
        <Box
            className={classes.list}
            role="presentation"
            onClick={props.toggleDrawerHandler}
            onKeyDown={props.toggleDrawerHandler}
            alignItems="stretch"

        >
            <List>
                {["Accueil", "Notre méthodologie", "Nous Contacter"].map((text, index) => (
                    <ListItem button key={text} onClick={(event) => updateTab(event, index)}>
                        <ListItemText primary={text} />
                    </ListItem>
                ))}
            </List>
            <Divider />

            <List>
                {
                    user?.isAuthenticated &&
                    <Fragment>
                        <ListItem button key="account" onClick={(event) => { history.push('/workspace/dashboard'); updateTab(event, -1); }}>
                            <ListItemText primary="Mon Espace" />
                        </ListItem>
                        <ListItem button key="logout" onClick={() => logout()}>
                            <ListItemText primary="Se déconnecter" />
                        </ListItem>
                    </Fragment>
                }
                {!user?.isAuthenticated &&
                    <ListItem button key="login" onClick={() => login("/workspace/dashboard")}>
                        <ListItemText primary="Se Connecter" />
                    </ListItem>
                }
            </List>

        </Box>
    );

    return (
        <Drawer open={opened} onClose={props.toggleDrawerHandler}>
            {sideList()}
        </Drawer>
    );
}

export default withStyles(styles)(withAuthProvider(DrawerMenu, false));